<template>
  <div 
    class="templatePopupWrap"
    :class="status.templatePopupViewBln ? 'active' : null "
    @click="dimmedClickHandler" 
  >
    <div class="contentWrap" ref="contentWrap">
      <h2>템플릿 불러오기</h2>
      <div class="scrlWrap">
        <ThumbnailWrap 
          v-for="thumb in list" 
          :thumb="thumb"
          :closeHandler="closeHandler" 
        />
      </div>
      <button class="closeBtn" @click="closeHandler">
        <svg viewBox="0 0 14 14" fill="none">
          <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="#333333"/>
        </svg>
        <span>닫기</span>
      </button>
    </div>
  </div>
</template>

<script>
import { commNewMapGetters , commNewMapMutations } from "@processEditor/CommNew";
import ThumbnailWrap from './comp/ThumbnailWrap' ; 
export default {
  components : {
    ThumbnailWrap , 
  } , 
  data () {
    return {
      list : [] , 
    }
  } , 
  computed : {
    ...commNewMapGetters([
      'status' , 
    ]) , 
  } , 
  watch : {
    'status.templatePopupViewBln' : {
      deep : true , 
      handler ( bln ) {
        // console.log( 'bln : ' , bln ) ; 
      } , 
    } , 
  } , 
  mounted () {
    this.templateLoadFunc() ; 
  } , 
  methods : {
    ...commNewMapMutations([
      'updateStatus' , 
    ]) , 
    closeBtnClickHandler ( e ) {
      let { closeHandler } = this ; 
      closeHandler() ; 
    } , 
    dimmedClickHandler ( e ) {
      let { closeHandler , $refs : { contentWrap }} = this ; 
      if ( contentWrap.contains( e.target )) return ; 
      closeHandler() ; 
    } , 
    closeHandler () {
      let { updateStatus } = this ; 
      updateStatus({ templatePopupViewBln : false }) ; 
    } , 

    async templateLoadFunc () {
      const { content : templateList , ...info } = await this.$wApi.process.search({
        // query: '',
        // targetField: 'name',
        // fieldId: null , 
        processType:'TEMPLATE',
        pageNo: 1 , 
        perPage: 50 , 
        isProtocol: 0,
        isThumbnail: 1,
        isMyData: 0
      }); 
//?processType=TEMPLATE&isThumbnail=1&isProtocol=0&pageNo=1&perPage=10&isMyData=0
      this.list = templateList.filter(o=>o.processType == 'TEMPLATE') ; 
    } , 
  }
} 
</script>


<style lang="scss" scoped>
  .templatePopupWrap {
    position: fixed; 
    z-index: 10; 
    left: 0; top: 0; width: 100%; height: 100%; 
    display: flex; 
    justify-content: center; align-items: center; 
    visibility: hidden; 
    transition: visibility 0.475s , backdrop-filter 0.475s; 
    backdrop-filter: blur( 0px ); 

    .contentWrap {
      display: flex; 
      flex-direction: column; 
      width: 992px; 
      height: 723px; 
      padding: 24px; 
      gap: 24px;
      background-color: $white; 
      border: 1px solid $gray-9; 
      position: relative; 
      opacity: 0; 
      transform: scale( 0 ); 
      transition-property: transform , opacity; 
      transition-duration: 0.475s , 0.475s; 
      transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.125);

      > h2 {
        display: flex; 
        flex-shrink: 0; 
        align-items: center; 
        height: 24px; 
      }

      .scrlWrap {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap; 
        align-items: flex-start;
        padding: 0px;
        // gap: 16px; 
        gap: 24px var( --default-gap ); 

        width: 944px;
        height: 627px;
        overflow: hidden; 
        overflow-y: auto;

        @include scrlbar;
      } // end of .scrlWrap 
      
      .closeBtn {
        font-size: 0; 
        width: 24px; height: 24px; 
        display: flex; 
        justify-content: center; 
        align-items: center; 
        position: absolute; 
        right: 24px; top: 24px; 
        cursor: pointer;
        svg {
          width: 14px; height: 14px; 
        }
      } // end of .closeBtn 
    } // end of .contentWrap


    &.active {
      visibility: visible; 
      // backdrop-filter: blur( 2px ); 
      .contentWrap {
        opacity: 1; 
        transform: scale( 1 ); 
      }
    }
  } // end of .templatePopupWrap
</style>